
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.16 19.414H5.525c-1.492 0-2.99-1.124-3.405-2.558L.11 9.935C-.35 8.35.678 6.98 2.327 6.98h.358V3.426a2.84 2.84 0 012.84-2.84h5.684c.648 0 1.36.412 1.68.973l.72 1.257c.066.117.307.257.441.257h7.106A2.844 2.844 0 0124 5.913v10.66a2.84 2.84 0 01-2.84 2.841zM4.107 6.98h13.857c1.492 0 2.99 1.125 3.405 2.558l1.211 4.17V5.913c0-.782-.638-1.42-1.423-1.42H14.05c-.644 0-1.356-.412-1.676-.972l-.718-1.257c-.067-.118-.308-.257-.447-.257H5.525c-.784 0-1.419.635-1.419 1.419V6.98z","fill":"#fff"}})])
          )
        }
      }
    